// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.URcRiNdAv07CHg {
  bottom: var(--ds-space-200, 16px);
  transition: bottom 0.3s ease-in-out;
}
.URcRiNdAv07CHg.xA29Q84JtyNLPQ {
  bottom: -100px;
}
.QCj82MrkK79qQh {
  bottom: var(--ds-space-0, 0);
  border-top: 1px solid var(--ds-border, #dfe3e8);
}
.QCj82MrkK79qQh > div > div:last-child {
  flex: 0 0 36px;
}
.esxy9NhRVQXI35 {
  display: flex;
  flex-direction: row;
  gap: var(--ds-space-075, 6px);
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding: 1px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"configurationPanels": `URcRiNdAv07CHg`,
	"isCardRoute": `xA29Q84JtyNLPQ`,
	"configurationTabs": `QCj82MrkK79qQh`,
	"horizontalRow": `esxy9NhRVQXI35`
};
export default ___CSS_LOADER_EXPORT___;
